<template>
  <section :class="name === 'ip-index-module' ? 'position-ip' : 'position-index'">
    <div class="module_title">
      <span class="en">{{ en }}</span>
      <span class="num" :class="`num_${index}`" />
      <span class="tit">{{ name === 'ip-index-module' ? '展示图' : `${title}场地` }}</span>
      <span class="en">{{ en }}</span>
    </div>
    <div class="float-bg" />
    <div class="position-main">
      <img :src="data.comImg || IMG_LIST.NO_DATA_IMG" alt />
    </div>
  </section>
</template>
<script>
import { IMG_LIST } from '../mock-data'

export default {
  data() {
    return {
      IMG_LIST,
      isShowPop: false,
    }
  },
  props: {
    en: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    index: {
      type: Number,
      default: 1,
    },
    title: {
      type: String,
      default: '漫画',
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  methods: {},
  mounted() {},
}
</script>
<style lang="less">
.position-index,
.position-ip {
  position: relative;
  margin: 0 auto;
  width: 1090px;
  .float-bg {
    width: 644px;
    height: 247px;
    top: -53px;
    left: -170px;
  }
  .position-main {
    position: relative;
    background: #2f15a2;
    margin-top: 46px;
    margin-bottom: 72px;
    width: 1090px;
    height: 647px;
    &::before {
      position: absolute;
      top: 10px;
      bottom: 0;
      left: 0;
      right: 20px;
      display: block;
      content: '';
      background: #030207;
    }
    &::after {
      position: absolute;
      top: 30px;
      bottom: -10px;
      left: -10px;
      right: 40px;
      display: block;
      content: '';
    }
    img {
      position: absolute;
      top: 32px;
      left: -8px;
      z-index: 2;
      width: 1057px;
      height: 623px;
      object-fit: cover;
    }
  }
}
.position-index {
  .position-main {
    &::after {
      background: #ceff1a;
      background: linear-gradient(45deg, transparent 40px, #ceff1a 0);
    }
    img {
      clip-path: polygon(0 0, 100% 0, 100% 100%, 55px 100%, 0 567px);
    }
  }
}
.position-ip {
  .position-main {
    &::after {
      background: #ceff1a;
    }
  }
}
</style>
